/* eslint-disable import/no-cycle */
import { useState } from "react";
import { MainMenu } from "ProfileComponents";
import Banner from "ProfileComponents/Navigation/Banner";
import utils from "Profile/utils/index";
// eslint-disable-next-line unused-imports/no-unused-imports
import ProfileNavigation from "./ProfileNavigation";
import Header from "../common/Header";
import OrderInfo from "./OrderInfo";
import { useScreenWidth } from "../SubscriptionPageV2/hooks";
import { useLocation } from "react-router";
// eslint-disable-next-line unused-imports/no-unused-imports
import MobileNavigation from "./MobileNavigation";
import BlackFridayBanner from "../common/BlackFridayBanner";
import { useSelector } from "react-redux";
import { CSSTransition } from "react-transition-group";

function NavBar({
  showTop = true,
  userLoggedIn = false,
  bannerText = "",
  hasSubscription = null,
  bannerData = { code: "", copy: "" },
  userName = "",
}) {
  const [mainActive, setMainActive] = useState(false);
  const [profileActive, setProfileActive] = useState(false);
  const location = useLocation();
  const isMobileScreen = useScreenWidth() < 768;
  const isHomePage = location.pathname.indexOf("home") !== -1;
  const ctaCopy = useSelector((state) => state.referalInfo.ctaCopy);
  const seasonalPromotion = useSelector((state) => state.profileSeasonalPromotion.bannerData);

  const toggleActive = () => {
    setMainActive(!mainActive);
    setProfileActive(!profileActive);
  };
  const hideBanner = !isHomePage;

  const isTarget = location.pathname.indexOf("target") !== -1;

  return (
    <>
      <div
        className="profile-navbar-wrapper"
        style={{ display: "flex", flexDirection: "column", position: "sticky", top: 0, left: 0 }}
      >
        {!bannerText && !isTarget && !hasSubscription && (
          <CSSTransition classNames="banner_1m_order" timeout={500} in={!!seasonalPromotion.code}>
            <BlackFridayBanner className="banner_1m_order_profile" data={seasonalPromotion} />
          </CSSTransition>
        )}
        <Header
          setProfileActive={setProfileActive}
          setMainActive={setMainActive}
          profileActive={profileActive}
          mainActive={mainActive}
          toggleActive={toggleActive}
          userLoggedIn={userLoggedIn}
          userName={userName}
          referralCTACopy={ctaCopy}
        />
      </div>

      {showTop && !utils.isReactivationRoute(window.location) && (
        <>
          {!hideBanner && <Banner />}
          <OrderInfo />
        </>
      )}
      {!userLoggedIn && <MainMenu in={mainActive} toggle={toggleActive} setMainActive={setMainActive} />}
    </>
  );
}

export default NavBar;
